export type Language = (typeof languages)[number];

export const languages = ["da", "en", "de"];
export const defaultLanguage = "da";
export const languageHeader = "accept-language";
